import React, { useEffect, useState } from 'react';
import { transformDateHelper } from 'src/helpers/transformDateHelper';
import { DateFormat } from 'src/constants/dateTimeFormatOption';
import { formatPaymentAmount } from 'src/pages/SubscriptionPage/PaymentHistorySection/formatPaymentAmount';
import { useGetInvoicePdfQuery } from 'src/services';
import type { Payment } from 'src/services/billingService';
import { useLoaderWhile } from 'src/hooks/useLoaderWhile';

interface PaymentHistoryPdfPopupFormProps {
  close: () => void;
  payment: Payment;
}

export const PaymentHistoryPdfPopupForm = ({ close, payment }: PaymentHistoryPdfPopupFormProps) => {
  const [downloadPdf, setDownloadPdf] = useState(false);

  const {
    data: invoicePdf,
    isFetching: invoicePdfIsFetching,
    isSuccess: invoicePdfIsSuccess,
  } = useGetInvoicePdfQuery(
    {
      payment_id: payment.id,
    },
    { skip: !downloadPdf },
  );

  useLoaderWhile(invoicePdfIsFetching);

  useEffect(() => {
    if (invoicePdfIsSuccess) {
      close();
    }
  }, [invoicePdfIsSuccess]);

  useEffect(() => {
    if (invoicePdf?.receipt_url) {
      const url = invoicePdf.receipt_url;
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = url;
      document.body.appendChild(link);
      link.click();
      link.remove();
      globalThis.URL.revokeObjectURL(url);
    }
  }, [invoicePdf]);

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setDownloadPdf(true);
  };

  return (
    <form id="download-receipt-form" onSubmit={submit}>
      <div className="flex flex-col gap-3.5">
        <div>
          <p className="text-base font-medium text-ebony font-jamjuree">
            {transformDateHelper(payment.created, DateFormat.MONTH_DAY_YEAR)}
          </p>
        </div>
        <div>
          <p className="text-base font-medium text-ebony">{payment.description}</p>
        </div>
        <div>
          <p className="text-base font-medium text-ebony">{formatPaymentAmount(payment)}</p>
        </div>
      </div>
    </form>
  );
};
